<template>
    <div>
        <div v-if="showSizeForm == false" class="d-flex border-bottom py-3 align-items-center text-center">
            <button type="button" class="btn btn-secondary" @click="addMoreTyres()" >Add a different size?</button>
        </div>
        <div v-else class="border-bottom text-center py-3">
            <b class="d-block mb-2">Select a tyre size</b>
            <modal-size-form
                :postcode="postcode"
                :options="sizeOptions"
                :tyre-position="tyrePositionText"
                :selected-size-option="selectedSizeOption"
                :show-modal-custom-button="true"
                @toggleSizeForm="toggleSizeForm()"
            ></modal-size-form>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'tyrePosition',
            'tyrePositionText',
            'postcode',
            'sizeOptions',
            'errors'
        ],
        data() {
            return {
                showSizeForm: false,
                car: {},
                selectedSizeOption: {}
            }
        },
        methods: {
            toggleSizeForm() {
                this.showSizeForm = !this.showSizeForm;
                this.emitter.emit('toggleDisabled');
            },
            updateSelectedOption(data) {
                //This prepopulates the size-form component with the selected size options.
                let split = window._split([data], '/');
                let speed = split[3].charAt(0).toUpperCase();

                if(typeof(split) != 'undefined') {
                    this.selectedSizeOption = {width: split[0], profile: split[1], rim: split[2], speed: speed};
                }
            },
			async addMoreTyres() {
                this.emitter.emit('toggleDisabled');
                this.emitter.emit('isLoading', true);

				let response = await axios.get('/get-car');

				if(response.data != null) {
					this.showSizeForm = true;
					this.car = response.data;
				}
                
                this.emitter.emit('isLoading', false);
			}
        },
        computed: {

        }
    }
</script>

<style lang="scss" scoped>

</style>